export abstract class AppRoutes {
  public static readonly index = "/";
  public static readonly mySessions = "/sessions/my";
  public static readonly organizationSessions = "/sessions/organization";
  public static readonly mySession = "/sessions/my/:id";
  public static readonly organizationSession = "/sessions/organization/:id";
  public static readonly lessons = "/lessons";
  public static readonly lesson = "/lessons/:id";
  public static readonly lessonEditor = "/lessons/:id/edit";
  public static readonly login = "/login";

  private static encodeParam(value: string | number) {
    return encodeURIComponent(String(value));
  }

  public static mySessionPath(id: string | number) {
    return `/sessions/my/${AppRoutes.encodeParam(id)}`;
  }

  public static organizationSessionPath(id: string | number) {
    return `/sessions/organization/${AppRoutes.encodeParam(id)}`;
  }

  public static lessonPath(id: string | number) {
    return `/lessons/${AppRoutes.encodeParam(id)}`;
  }

  public static lessonEditorPath(id: string | number) {
    return `/lessons/${AppRoutes.encodeParam(id)}/edit`;
  }
}
